// extracted by mini-css-extract-plugin
module.exports = {"preference":"_7a331177","icon":"_f72752a7"};